// Validator for the message prop used by AiAgentCliMessage. Catches drift
// between the store and the renderer in dev (Vue logs a warning when the
// validator returns false).

export function isValidMessage(msg) {
  if (!msg || typeof msg !== 'object') {
    return false
  }

  if (msg.role !== 'user' && msg.role !== 'assistant') {
    return false
  }

  if (msg.role === 'user') {
    return typeof msg.text === 'string'
  }

  // assistant
  return Array.isArray(msg.tools) && Array.isArray(msg.citations)
}
